<template>
    <!-- Inspect-able List -->
    <div
        id="inspectable-list"
        class="col-sm-12 nopads"
    >
        <div
            class="data-list-item add"
            @click.stop="$emit('add')"
        >
            <div class="item-img-cont add-title">
                <i class="fa fa-plus"/>
            </div>
            <div class="item-text-cont">
                <span class="item-title-add">{{ $t('common.add_new') }}</span>
                <font-awesome-icon
                    icon="check-square"
                    class="card-body-icon"
                />
            </div>
        </div>

        <Transition name="fade">
            <div v-if="results.length > 0" class="col-sm-12 pb-2 mt-3 result-table">
                <vue3-datatable
                    ref="resultTable"
                    :rows="results"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    height="52em"
                    :sortable="true"
                    skin="bh-table-compact"
                    row-class="routa-table-row"
                    cell-class="routa-table-cell"
                    sort-column="name"
                    sort-direction="asc"
                    @row-click="emitEdit"
                >
                    <template #empty>
                        <div class="text-center my-2">
                            {{ $t('area_report.no_results') }}
                        </div>
                    </template>
                    <template #type="row">
                      {{  $t(`inspectable.types.${types[row.value.type]}`) }}
                    </template>
                </vue3-datatable>
            </div>
        </Transition>
    </div>
</template>

<script>
import {types} from "@/modules/Inspectable";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'InspectionList',
    components: {Vue3Datatable},
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        },
    },
    data() {
        return {
            types,
            fields: [
                {field: 'name', title: this.$t('inspectable_editor.name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'type', title: this.$t('inspectable_editor.type'), sort: true, headerClass: 'routa-table-header'}
            ]
        }
    },
    methods: {
        emitEdit(item) {
            this.$emit('edit', item)
        }
    }
}
</script>
